import api from '.';

export const USUARIOS_ENDPOINT = '/usuarios';

export const getAllUsuarios = async (params) => {
    const response = await api.get(USUARIOS_ENDPOINT, { params });
    return response;
};

export const getUsuarioById = async (id) => {
    const response = await api.get(`${USUARIOS_ENDPOINT}/${id}`);
    return response;
};

export const createUsuario = async (params) => {
    const response = await api.post(USUARIOS_ENDPOINT, params);
    return response;
};

export const updateUsuario = async (params) => {
    const response = await api.put(USUARIOS_ENDPOINT, params);
    return response;
};

export const deleteUsuario = async (id) => {
    const response = await api.delete(`${USUARIOS_ENDPOINT}/${id}`);
    return response;
};

export const checkUsernameAvailability = async (params) => {
    const response = await api.get(
        `${USUARIOS_ENDPOINT}/username-availability`,
        {
            params,
        }
    );
    return response;
};
